import React, { useEffect, useState } from "react";
import * as PropTypes from "prop-types";
import { BigNumber, providers } from "ethers";
import { observer } from "mobx-react-lite";
import { formatRounded } from "../../../../services/numbers";
import appStore from "store/app.store";
import { formatThousand } from "../../../../utils/helpers";
import { useAccount } from "wagmi";

const readProvider = new providers.JsonRpcProvider(
  process.env.REACT_APP_RPC_URL
);

const InfoBlock = observer(({ poolsArr }) => {
  const [totalReward, setTotalReward] = useState(0);
  const [totalRewardInUsd, setTotalRewardInUsd] = useState(0);
  const [totalStaked, setTotalStaked] = useState(0);
  const [totalStakedInUsd, setTotalStakedInUsd] = useState(0);
  const [balance, setBalance] = useState();
  const [balanceInUsd, setBalanceInUsd] = useState();

  const { isConnected: isActive, address: account, chainId } = useAccount();

  let poolsRewards = [];
  let myTotalStake = [];

  const totalRewardCalculateHandler = (estd) => {
    poolsRewards.push(estd);
    if (poolsRewards.length === poolsArr.length) {
      const rewardInAmb =
        poolsRewards.length > 0 &&
        poolsRewards.reduceRight((acc, curr) => acc + +curr, 0);
      setTotalReward(rewardInAmb);
      const esdSum =
        appStore.tokenPrice &&
        poolsRewards.length > 0 &&
        poolsRewards.reduceRight((acc, curr) => acc + +curr, 0);
      setTotalRewardInUsd(0);
      if (esdSum && esdSum > 0 && appStore.tokenPrice) {
        setTotalRewardInUsd(esdSum * appStore.tokenPrice);
      }
    }
  };

  const totalStakeCalculateHandler = (stake) => {
    myTotalStake.push(stake);
    if (myTotalStake.length === poolsArr.length) {
      const totalStakeSum = myTotalStake.reduceRight(
        (acc, curr) => acc.add(curr),
        BigNumber.from("0")
      );
      setTotalStaked(totalStakeSum);
      if (totalStakeSum && appStore.tokenPrice) {
        const TsSum = formatRounded(totalStakeSum);
        setTotalStakedInUsd(TsSum * appStore.tokenPrice);
      }
    }
  };

  const getBalance = async () => {
    if (isActive) {
      const bnBalance = await readProvider.getBalance(account);
      const numBalance = formatRounded(bnBalance, 2);
      setBalance(formatThousand(numBalance));
      if (appStore.tokenPrice) {
        setBalanceInUsd(formatThousand(numBalance * appStore.tokenPrice));
      }
    }
  };

  const getInfo = async () => {
    if (poolsArr.length > 0) {
      poolsRewards = [];
      myTotalStake = [];
      poolsArr.forEach((pool) => {
        const { estAR, myStakeInAMB } = pool;
        if (estAR) totalRewardCalculateHandler(estAR);
        if (myStakeInAMB) totalStakeCalculateHandler(myStakeInAMB);
      });
    }
    await getBalance();
  };

  useEffect(() => {
    if (isActive && chainId === +process.env.REACT_APP_CHAIN_ID) {
      getInfo();
    } else {
      const zero = formatThousand(0);

      setTotalReward(0);
      setTotalRewardInUsd(0);
      setTotalStaked(0);
      setTotalStakedInUsd(0);
      setBalance(zero);
      setBalanceInUsd(zero);
    }
  }, [
    poolsArr,
    totalRewardInUsd,
    totalStakedInUsd,
    isActive,
    account,
    chainId,
  ]);

  return (
    <section className="user-info">
      <div className="user-info__content content">
        <div className="user-info__cell">
          <div className="user-info__title">AVAILABLE FOR STAKING</div>
          {balance ? (
            <div className="user-info__value">
              <div className="user-info__value-amb">{balance} AMB</div>
              <div className="user-info__value-usd">${balanceInUsd}</div>
            </div>
          ) : (
            <div className="user-info__value">
              <div className="user-info__value-amb">
                {formatThousand(0)} AMB
              </div>
              <div className="user-info__value-usd">${formatThousand(0)}</div>
            </div>
          )}
        </div>
        <div className="user-info__cell">
          <div className="user-info__title">CURRENTLY STAKING</div>
          {totalStaked ? (
            <div className="user-info__value">
              <div className="user-info__value-amb">
                {formatThousand(formatRounded(totalStaked, 2))} AMB
              </div>
              <div className="user-info__value-usd">
                ${formatThousand(totalStakedInUsd)}
              </div>
            </div>
          ) : (
            <div className="user-info__value">
              <div className="user-info__value-amb">
                {formatThousand(0)} AMB
              </div>
              <div className="user-info__value-usd">${formatThousand(0)}</div>
            </div>
          )}
        </div>
        <div className="user-info__cell">
          <div className="user-info__title">EARNINGS</div>
          {balance ? (
            <div className="user-info__value">
              <div className="user-info__value-amb">
                {formatThousand(totalReward)} AMB
              </div>
              <div className="user-info__value-usd">
                ${formatThousand(totalRewardInUsd)}
              </div>
            </div>
          ) : (
            <div className="user-info__value">
              <div className="user-info__value-amb">
                {formatThousand(0)} AMB
              </div>
              <div className="user-info__value-usd">${formatThousand(0)}</div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
});

InfoBlock.propTypes = {
  poolsArr: PropTypes.array,
};

export default React.memo(InfoBlock);
